import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type { UUID } from "../base/ui_general/GeneralInterfaces";
import type { FetchRequest } from "../base/ui_general/GeneralInterfaces";
import type { TransactionSettings } from "../base/ui_general/GeneralInterfaces";

/**
 * Returns a FetchRequest for retrieving transaction settings for a given transaction ID.
 * @param transaction_id UUID of the transaction whose settings are to be fetched.
 */
export function getRequest_get_transaction_settings(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRANSACTION_SETTINGS,
        method: HttpMethods.GET,
        query_parameters: { transaction_id },
    };
}

/**
 * Returns a FetchRequest for updating transaction settings via PUT.
 * @param transaction_settings The TransactionSettings object to update.
 */
export function getRequest_update_transaction_settings(transaction_settings: TransactionSettings): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.TRANSACTION_SETTINGS,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: transaction_settings,
    };
}
